import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/styles/brand.css";
import "@/styles/global-theme.css";
import App from "@/App";

// Runtime CSS variable — the altar-frontal image lives in /public/brand
// and cannot be referenced via url() inside imported CSS (CRA's css-loader
// tries to resolve at build time). Setting the token at root here means
// every `.li-altar-frieze`, `.li-altar-header`, `.li-altar-wash-bg`
// selector picks it up correctly at runtime.
document.documentElement.style.setProperty(
  "--li-altar-frontal-url",
  "url('/brand/altar-frontal.webp')",
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the service worker for installable PWA / offline shell.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
